import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  HostListener,
  ChangeDetectorRef,
  ElementRef,
  QueryList,
  ViewChildren,
} from '@angular/core';
//import { ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
//import { NgOptimizedImage } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthenticationService } from '@core/services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ProfileService } from '@core/services/profile.service';
import { NavbarViewManagerService } from '@core/services/navbar-view-manager.service';
import { CompanyService } from '@core/services/company.service';
import { FinancialDocumentsViewService } from '@core/services/financial-documents-view.service';
import {
  faAngleDown,
  faAngleUp,
  faChevronRight,
  faLink,
  faBell,
  faGear,
} from '@fortawesome/pro-regular-svg-icons';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { ProfileMenuComponent } from '../profile-menu/profile-menu.component';
//import { faAngleDown, faAngleUp, faBuildings, faGear } from '@fortawesome/pro-regular-svg-icons';
// import { faUser } from '@fortawesome/pro-solid-svg-icons';
import { ChatStateService } from '@core/services/chat-state.service';
import {
  AgentStateService,
  AgentData,
} from '@core/services/agent-state.service';
import { getAgentCategoryIcon } from '@core/utils/agent-icon.utils';
import {
  getAgentImageByName,
  getAgentCardIcon,
  AgentIconConfig,
} from '@core/utils/agent-images.utils';
import { normalizeAgentDisplayName } from '@core/utils/agent-name.utils';
import {
  ConnectionsStateService,
  SelectedChatConnection,
} from '@core/services/connections-state.service';
import { ConnectionsDisplayUtils } from '@core/utils/connections-display.utils';
import {
  AgentConnection,
  getAllConnections,
} from '@core/utils/agent-connections.utils';
import { ConnectionService } from '@core/services/connection.service';
import { Connection } from '@core/services/connection.service';
import { ConnectionsStoreService } from '@core/services/connections-store.service';
import { NavigationShellStateService } from '@core/services/navigation-shell-state.service';

@Component({
  selector: 'app-top-navbar',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, FormsModule, ProfileMenuComponent],
  templateUrl: './top-navbar.component.html',
  styleUrl: './top-navbar.component.css',
})
export class TopNavbarComponent implements OnInit, OnDestroy, AfterViewInit {
  private static readonly SELECTED_CONNECTION_IDS_KEY =
    'selectedConnectionIdsByType';
  @ViewChildren('navbarCard') navbarCards?: QueryList<ElementRef<HTMLElement>>;
  private resizeObserver?: ResizeObserver;
  private hasAutoOpenedConnectionDropdown = false;
  isMobile = false;
  isPersonalProfileRoute = false;
  isChatRoute = false;
  isFinancialDocumentsRoute = false;
  isMenuExpanded = false;
  isSidebarOpen = false;
  userInfo: {
    name: string;
    email: string;
    profile_image_url?: string;
    roles: Array<{
      id: number;
      name: string;
      guard_name: string;
    }>;
    company?: {
      name: string;
      is_company: boolean;
    };
  } = {
      name: '',
      email: '',
      profile_image_url: '',
      roles: [],
      company: undefined,
    };

  // isDropdownProfileOpen = false;
  // showUserProfile = false;
  private subscriptions: Subscription[] = [];

  // Propiedades para el selector de agentes
  isDropdownAgentOpen = false;
  products: AgentData[] = [];
  filteredProducts: AgentData[] = [];
  agentSearchQuery = '';
  currentAgentData: any = null;
  activeTab: 'all' | 'experts' | 'marketplace' = 'all';

  // Agentes categorizados
  userProducts: AgentData[] = [];
  companyProducts: AgentData[] = [];
  expertsProducts: AgentData[] = [];
  marketplaceProducts: AgentData[] = [];

  // Propiedades para detectar estado del chat
  hasExistingChat = false;
  isNewChat = false;
  messageHasBeenSent = false;

  // Propiedades para el dropdown de conexiones
  showConnectionDropdown = false;
  connectionDropdownHasMoreBelow = false;
  isMobileChatHeaderCollapsed = false;
  private hasUserToggledMobileChatHeader = false;
  selectedConnections: string[] = [];
  realConnections: Connection[] = []; // Conexiones reales del API con nombres personalizados
  connectedConnections: AgentConnection[] = [];
  companyContextEnabled = false;

  // Indicadores de estado de chats en procesamiento
  hasProcessingChat = false;
  processingChatIds: string[] = [];

  faChevronRight = faChevronRight;
  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;
  faLink = faLink;
  faBell = faBell;
  faGear = faGear;
  faUser = faUser;
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    //private eRef: ElementRef,
    private profileService: ProfileService,
    private chatState: ChatStateService,
    private navbarViewManager: NavbarViewManagerService,
    private agentStateService: AgentStateService,
    private companyService: CompanyService,
    private financialDocumentsViewService: FinancialDocumentsViewService,
    private connectionsStateService: ConnectionsStateService,
    private connectionService: ConnectionService,
    private connectionsStore: ConnectionsStoreService,
    private navigationShellState: NavigationShellStateService,
    private cdr: ChangeDetectorRef,
  ) {
    this.subscriptions.push(
      this.navigationShellState.state$.subscribe(
        ({ isMobile, isMenuExpanded: expanded, isSidebarOpen }) => {
          this.isMobile = isMobile;
          this.isMenuExpanded = expanded;
          this.isSidebarOpen = isSidebarOpen;
          setTimeout(() => this.updateChatHeaderOffset(), 0);
        },
      ),
    );

    this.subscriptions.push(
      this.chatState.activeStreams$.subscribe((streams) => {
        let hasActive = false;
        const processingIds: string[] = [];
        streams.forEach((state) => {
          if (!state.isComplete) {
            hasActive = true;
            if (state.chatId) {
              processingIds.push(state.chatId);
            }
          }
        });
        this.hasProcessingChat = hasActive;
        this.processingChatIds = processingIds;
        this.cdr.markForCheck();
      }),
    );
  }

  ngOnInit(): void {
    const savedConnections = localStorage.getItem('selectedConnections');
    if (savedConnections) {
      try {
        const parsedConnections = JSON.parse(savedConnections);
        this.selectedConnections = Array.isArray(parsedConnections)
          ? parsedConnections.slice(-1)
          : [];
        localStorage.setItem(
          'selectedConnections',
          JSON.stringify(this.selectedConnections),
        );
      } catch (e) {
        this.selectedConnections = [];
      }
    }

    this.subscriptions.push(
      this.authService.currentUser$.subscribe((userData) => {
        if (userData) {
          this.userInfo = {
            name: userData.name || '',
            email: userData.email || '',
            profile_image_url: userData.profile_image_url || '',
            roles: userData.roles || [],
            company: userData.company,
          };
        }
      }),
    );

    this.subscriptions.push(
      this.profileService.userProfile$.subscribe((userProfile) => {
        if (userProfile) {
          const u = userProfile.user as any;
          this.userInfo = {
            ...this.userInfo,
            name: u?.name != null ? u.name : this.userInfo.name,
            email: u?.email != null ? u.email : this.userInfo.email,
            profile_image_url:
              userProfile.profile_image_url ??
              this.userInfo.profile_image_url ??
              '',
          };
        }
      }),
    );

    this.subscriptions.push(
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.isPersonalProfileRoute = event.url === '/dashboard/profile';
          this.isChatRoute = event.url === '/dashboard/chat';
          this.isFinancialDocumentsRoute =
            event.url === '/dashboard/financial-documents';
          this.checkExistingChat();
          this.applyConnectionUiRules();
          this.applyMobileChatHeaderDefaultCollapse();
          setTimeout(() => this.updateChatHeaderOffset(), 0);
        }),
    );

    this.isPersonalProfileRoute = this.router.url === '/dashboard/profile';
    this.isChatRoute = this.router.url === '/dashboard/chat';
    this.isFinancialDocumentsRoute =
      this.router.url === '/dashboard/financial-documents';

    this.checkExistingChat();
    this.applyConnectionUiRules();
    this.applyMobileChatHeaderDefaultCollapse();
    this.companyContextEnabled =
      this.connectionsStateService.getCompanyContextEnabled();

    this.subscriptions.push(
      this.chatState.selectedChatId$.subscribe(() => {
        setTimeout(() => {
          this.checkExistingChat();
        }, 100);
      }),
    );

    this.subscriptions.push(
      this.chatState.messageSent$.subscribe((sent) => {
        this.messageHasBeenSent = sent;
        this.checkExistingChat();
      }),
    );

    this.subscriptions.push(
      this.chatState.deselectAllChats$.subscribe(() => {
        setTimeout(() => {
          this.checkExistingChat();
          this.ensureDefaultConnectionSelectionForNewChat();
        }, 50);
      }),
    );

    this.subscriptions.push(
      this.connectionsStateService.connections$.subscribe(() => {
        this.loadRealConnections();
        this.cdr.detectChanges();
      }),
    );

    this.subscriptions.push(
      this.connectionsStateService.companyContextEnabled$.subscribe(
        (enabled) => {
          this.companyContextEnabled = enabled;
          if (enabled) {
            this.setConnectionDropdownVisibility(false);
          }
          this.applyConnectionUiRules();
          this.applyMobileChatHeaderDefaultCollapse();
          this.cdr.markForCheck();
        },
      ),
    );

    this.subscriptions.push(
      this.connectionsStateService.selectedChatConnectionClearRequests$.subscribe(
        () => {
          this.clearSelectedConnectionSelection();
        },
      ),
    );

    this.subscriptions.push(
      this.connectionsStateService.selectedChatConnection$.subscribe(
        (connection) => {
          this.syncSelectedConnectionsWithGlobalSelection(connection);
        },
      ),
    );

    this.loadAgents();
  }

  ngAfterViewInit(): void {
    this.updateChatHeaderOffset();
    if (this.navbarCards?.length && 'ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.updateChatHeaderOffset());
      this.navbarCards.forEach((card) => {
        this.resizeObserver?.observe(card.nativeElement);
      });
    }

    this.navbarCards?.changes.subscribe(() => {
      this.updateChatHeaderOffset();
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = undefined;
    }
    document.documentElement.style.removeProperty('--chat-header-offset');
  }

  private updateChatHeaderOffset(): void {
    const element = this.getActiveNavbarCard();
    if (!element) {
      document.documentElement.style.removeProperty('--chat-header-offset');
      return;
    }
    const rect = element.getBoundingClientRect();
    const extraGap = 8;
    const offset = Math.max(0, Math.ceil(rect.bottom + extraGap));
    document.documentElement.style.setProperty('--chat-header-offset', `${offset}px`);
  }

  private getActiveNavbarCard(): HTMLElement | null {
    if (!this.navbarCards?.length) {
      return null;
    }

    const visibleCard = this.navbarCards
      .map((card) => card.nativeElement)
      .find((element) => element.offsetParent !== null);

    return visibleCard ?? null;
  }

  /* deshabilitado temporalmente - menú del perfil
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isDropdownProfileOpen = false;
    }
  }

  toggleDropdownProfile(event: Event): void {
    event.stopPropagation();
    this.isDropdownProfileOpen = !this.isDropdownProfileOpen;
  }
  */

  onEditProfileClick() {
    this.navbarViewManager.closeAllNavbarViewsExcept('userProfile');
    this.profileService.showUserProfile();
    // this.isDropdownProfileOpen = false;
  }

  newChat() {
    this.chatState.startNewChat(this.agentStateService, this.navbarViewManager);
    this.navbarViewManager.handleSidebarForChat();
    this.router.navigate(['/dashboard/chat']);
  }

  hasUserRole(roleId: number): boolean {
    return this.userInfo.roles.some((role) => role.id === roleId);
  }

  onManageCompanyClick(): void {
    this.navbarViewManager.closeAllNavbarViewsExcept('companyProfile');
    this.profileService.showCompanyProfile();
    // this.isDropdownProfileOpen = false;
  }

  onSettingsClick(): void {
    this.router.navigate(['/dashboard/settings', 'general']);
  }

  // Métodos para el selector de agentes
  private loadAgents(): void {
    if (this.agentStateService.currentAgents.length > 0) {
      this.products = [...this.agentStateService.currentAgents];
      this.categorizeAgents();
      this.filteredProducts = [...this.products];
    } else {
      this.loadAgentsFromApi();
    }

    this.subscriptions.push(
      this.agentStateService.agents$.subscribe((data: AgentData[]) => {
        this.products = [...data];
        this.categorizeAgents();
        this.filteredProducts = [...this.products];
        this.filterAgents();
      }),
    );
  }

  /**
   * Carga las conexiones reales del API para mostrar en el dropdown con nombres personalizados
   */
  private loadRealConnections(): void {
    this.connectionsStore.loadAll().subscribe({
      next: (connections) => {
        this.realConnections = connections.filter(c => c.is_active);
        this.rebuildConnectedConnections();
        console.log('🔗 [TopNavbar] Conexiones disponibles recibidas:', this.connectedConnections);
        this.syncSelectionWithAvailableConnections();
        this.ensureDefaultConnectionSelectionForNewChat();
        this.syncGlobalSelectedChatConnection();
        this.applyConnectionUiRules();
        this.cdr.markForCheck();
      },
      error: (err) => {
        console.error('❌ Error cargando conexiones reales:', err);
        this.realConnections = [];
        this.connectedConnections = [];
        this.connectionsStateService.setSelectedChatConnection(null);
        this.applyConnectionUiRules();
      }
    });
  }

  private categorizeAgents(): void {
    this.userProducts = this.products.filter(
      (product) => product.category === 'user',
    );
    this.companyProducts = this.products.filter(
      (product) => product.category === 'company',
    );
    this.expertsProducts = [...this.userProducts, ...this.companyProducts];
    this.marketplaceProducts = this.products.filter(
      (product) =>
        product.category === 'marketplace' ||
        product.category === 'datasources',
    );

    this.updateFilteredProducts();
  }

  private loadAgentsFromApi(): void {
    if (this.agentStateService.isAgentsLoaded()) {
      return;
    }

    this.companyService.getCompanyProducts().subscribe({
      next: (data: AgentData[]) => {
        this.agentStateService.setAgents(data);
        this.agentStateService.markAgentsAsLoaded();
      },
      error: (error: any) => {
        console.error('Error cargando agentes:', error);
      },
    });
  }

  toggleDropdownAgent(event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.isDropdownAgentOpen = !this.isDropdownAgentOpen;
  }

  setActiveTab(tab: 'all' | 'experts' | 'marketplace'): void {
    this.activeTab = tab;
    this.updateFilteredProducts();
  }

  updateFilteredProducts(): void {
    switch (this.activeTab) {
      case 'all':
        this.filteredProducts = this.products.filter((product) =>
          product.agent_config.name
            .toLowerCase()
            .includes(this.agentSearchQuery.toLowerCase()),
        );
        break;
      case 'experts':
        this.filteredProducts = this.expertsProducts.filter((product) =>
          product.agent_config.name
            .toLowerCase()
            .includes(this.agentSearchQuery.toLowerCase()),
        );
        break;
      case 'marketplace':
        this.filteredProducts = this.marketplaceProducts.filter((product) =>
          product.agent_config.name
            .toLowerCase()
            .includes(this.agentSearchQuery.toLowerCase()),
        );
        break;
    }
  }

  selectAgent(agent: any): void {
    const idToUse =
      typeof agent.agent_id === 'number' && !isNaN(agent.agent_id)
        ? agent.agent_id
        : typeof agent.agent_config.id === 'number' &&
          !isNaN(agent.agent_config.id)
          ? agent.agent_config.id
          : null;

    if (idToUse) {
      const agentType =
        agent.category === 'datasources' ? 'datasource' : 'agent';
      const agentName = agent.agent_config?.name || '';

      this.currentAgentData = agent;

      this.applyAgentConfiguration(agent, idToUse);
      this.cdr.detectChanges();

      this.financialDocumentsViewService.hideFinancialDocuments();
      if (idToUse === 3) {
        this.financialDocumentsViewService.showFinancialDocuments();
      }
      localStorage.setItem('type_agent', agentType);
      localStorage.setItem('agent_id', idToUse.toString());

      // Buscar la imagen del agente por su nombre
      const agentImage = getAgentImageByName(agentName);
      if (agentImage) {
        localStorage.setItem('agent_image', agentImage);
      } else {
        localStorage.removeItem('agent_image');
      }

      this.agentStateService.setAgentId(idToUse);
      this.agentStateService.setCurrentAgent(agentName);

      this.chatState.startNewChat(
        this.agentStateService,
        this.navbarViewManager,
      );

      this.toggleDropdownAgent();
      this.navbarViewManager.closeAllNavbarViews();

      if (idToUse === 3) {
        this.router.navigate(['/dashboard/financial-documents']);
      } else {
        this.router.navigate(['/dashboard/chat']);
      }
    } else {
      console.error('No se puede abrir la conversación para este agente');
    }
  }

  private applyAgentConfiguration(
    foundProduct: AgentData,
    agentId: number,
  ): void {
    if (!foundProduct || !foundProduct.agent_config) {
      console.error('agent_config is null or undefined for agent:', agentId);
      return;
    }

    const config = {
      name: foundProduct.agent_config.name || `Agente ${agentId}`,
    };

    this.chatState.setCurrentAgent(config.name.toString());

    localStorage.setItem('agent_id', agentId.toString());
    this.cdr.detectChanges();
  }

  getCurrentAgentName(): string | null {
    return normalizeAgentDisplayName(this.chatState.getCurrentAgent());
  }

  getCurrentAgentIcon(): any {
    if (
      this.currentAgentData &&
      this.currentAgentData.agent_config?.name === this.getCurrentAgentName()
    ) {
      return getAgentCategoryIcon(this.currentAgentData);
    }

    const currentAgentId = localStorage.getItem('agent_id');
    const typeAgent = localStorage.getItem('type_agent');
    const isDatasource = typeAgent === 'datasource';

    if (currentAgentId) {
      const foundAgent = this.agentStateService.findAgentById(
        Number(currentAgentId),
        isDatasource,
      );

      if (
        foundAgent &&
        foundAgent.agent_config?.name === this.getCurrentAgentName()
      ) {
        return getAgentCategoryIcon(foundAgent);
      }

      const agentByName = this.products.find((agent: AgentData) => {
        return agent.agent_config?.name === this.getCurrentAgentName();
      });

      if (agentByName) {
        return getAgentCategoryIcon(agentByName);
      }

      if (foundAgent) {
        return getAgentCategoryIcon(foundAgent);
      }
    }

    const tempAgent = {
      agent_config: {
        name: this.getCurrentAgentName() || '',
        description: '',
      },
    };

    return getAgentCategoryIcon(tempAgent);
  }

  getAgentImageUrl(): string | null {
    const agentImageUrl = localStorage.getItem('agent_image');
    return agentImageUrl || null;
  }

  getAgentCardIconConfig(agentName: string | null): AgentIconConfig | null {
    if (!agentName) return null;
    return getAgentCardIcon(agentName);
  }

  getAgentIcon(agent: any): any {
    return getAgentCategoryIcon(agent);
  }

  filterAgents(): void {
    let filtered: AgentData[];

    if (!this.agentSearchQuery.trim()) {
      filtered = [...this.products];
    } else {
      const query = this.agentSearchQuery.toLowerCase().trim();
      filtered = this.products.filter((product) =>
        product.agent_config?.name?.toLowerCase().includes(query),
      );
    }

    this.filteredProducts = this.sortAgents(filtered);
  }

  onAgentSearchChange(): void {
    this.updateFilteredProducts();
  }

  private sortAgents(agents: AgentData[]): AgentData[] {
    const miAgenteIndex = agents.findIndex(
      (agent) => agent.agent_config?.name?.toLowerCase() === 'mi agente',
    );

    if (miAgenteIndex !== -1) {
      const miAgente = agents[miAgenteIndex];
      const otherAgents = agents.filter((_, index) => index !== miAgenteIndex);
      return [miAgente, ...otherAgents];
    }

    return agents;
  }

  getDropdownPositionClass(): string {
    if (typeof window !== 'undefined') {
      const screenWidth = window.innerWidth;
      return screenWidth < 1024 ? 'right-0' : 'right-0';
    }
    return 'right-0';
  }

  private checkExistingChat(): void {
    if (typeof window !== 'undefined') {
      const chatId = this.chatState.getPersistedChatId();
      this.hasExistingChat = !!chatId;

      // Es nuevo chat si:
      // 1. Estamos en ruta de chat/documentos
      // 2. No hay chat_id en localStorage
      // 3. No se ha enviado mensaje (messageHasBeenSent = false)
      this.isNewChat =
        (this.isChatRoute || this.isFinancialDocumentsRoute) &&
        !chatId &&
        !this.messageHasBeenSent;

      if (this.isNewChat) {
        this.ensureDefaultConnectionSelectionForNewChat();
      }

      // Forzar detección de cambios
      this.cdr.detectChanges();
    }
  }

  // Método público para forzar actualización cuando se selecciona un chat
  public updateChatState(): void {
    this.checkExistingChat();
  }

  @HostListener('document:click')
  handleDocumentClick(): void {
    this.isDropdownAgentOpen = false;
    this.setConnectionDropdownVisibility(false);
  }

  @HostListener('window:storage', ['$event'])
  onStorageChange(event: StorageEvent): void {
    if (event.key === 'chat_id') {
      this.checkExistingChat();
    }
  }

  /**
   * Abre/cierra el dropdown de conexiones
   */
  toggleConnectionDropdown(): void {
    if (this.isMobileChatHeaderCollapsed) {
      this.isMobileChatHeaderCollapsed = false;
      setTimeout(() => this.updateChatHeaderOffset(), 0);
    }
    this.setConnectionDropdownVisibility(!this.showConnectionDropdown);
  }

  updateConnectionDropdownScrollHint(event: Event): void {
    const element = event.currentTarget as HTMLElement | null;
    this.connectionDropdownHasMoreBelow =
      this.hasScrollableContentBelow(element);
  }

  toggleMobileChatHeaderCollapsed(event: Event): void {
    event.stopPropagation();
    this.hasUserToggledMobileChatHeader = true;
    this.isMobileChatHeaderCollapsed = !this.isMobileChatHeaderCollapsed;
    if (this.isMobileChatHeaderCollapsed) {
      this.setConnectionDropdownVisibility(false);
    }
    setTimeout(() => {
      this.updateChatHeaderOffset();
      this.cdr.markForCheck();
    }, 0);
  }

  /**
   * Alterna la selección de una conexión y sincroniza con el backend
   */
  toggleConnectionSelection(connectionId: string): void {
    const previousSelection = this.selectedConnections[0] || null;
    const isSameSelection = previousSelection === connectionId;

    if (isSameSelection) {
      this.clearSelectedConnectionSelection();
      this.connectionsStateService.setSelectedChatConnection(null);
      this.applyConnectionUiRules();
      this.cdr.markForCheck();
      return;
    }

    const connection = this.realConnections.find(
      (item) => `conn_${item.id}` === connectionId,
    );
    if (!connection) {
      this.displaySyncErrorAndReset();
      return;
    }

    this.selectConnectionAsActive(connection, true);
  }

  private selectConnectionAsActive(
    connection: Connection,
    persistBackendDefault: boolean,
  ): void {
    const connectionKey = `conn_${connection.id}`;
    this.selectedConnections = [connectionKey];
    localStorage.setItem(
      'selectedConnections',
      JSON.stringify(this.selectedConnections),
    );
    this.persistSelectedConnectionId(connectionKey, connection.id);
    this.persistSelectedConnectionId(connection.type, connection.id);
    this.syncGlobalSelectedChatConnection();
    this.applyMobileChatHeaderDefaultCollapse();
    this.setConnectionDropdownVisibility(false);
    this.applyConnectionUiRules();
    this.cdr.markForCheck();

    if (!persistBackendDefault || connection.is_default) {
      return;
    }

    this.connectionService.update(connection.id, { is_default: true }).subscribe({
      next: (response) => {
        if (response?.success === false) {
          this.syncSelectedConnectionsFromBackend();
          return;
        }
        this.applyDefaultFlagInStore(connection.id);
      },
      error: (error) => {
        console.error('Error al actualizar conexión:', error);
        this.syncSelectedConnectionsFromBackend();
      },
    });
  }

  /**
   * Obtiene las conexiones conectadas
   */
  getConnectionsConnected(): AgentConnection[] {
    return this.connectedConnections;
  }

  shouldShowConnectionDropdownScrollHint(): boolean {
    return (
      this.showConnectionDropdown &&
      this.connectionDropdownHasMoreBelow &&
      this.getConnectionsConnected().length > (this.isMobile ? 5 : 8)
    );
  }

  /**
   * Verifica si una conexión está seleccionada
   */
  isConnectionSelected(connectionId: string): boolean {
    return this.selectedConnections.includes(connectionId);
  }

  getSelectedConnection(): AgentConnection | null {
    const selectedConnectionId = this.selectedConnections[0];
    if (!selectedConnectionId) {
      return null;
    }

    // Buscar en las conexiones reales actualmente disponibles
    return this.getConnectionsConnected().find(
      (connection) => connection.id === selectedConnectionId,
    ) || null;
  }

  hasSelectedConnection(): boolean {
    return this.getSelectedConnection() !== null;
  }

  shouldShowDesktopConnectionCta(): boolean {
    return this.shouldShowConnectionBanner();
  }

  shouldShowMobileConnectionCta(): boolean {
    return this.shouldShowConnectionBanner();
  }

  shouldShowMobileChatHeader(): boolean {
    return (
      this.isMobile &&
      !this.isMenuExpanded &&
      !this.isSidebarOpen &&
      (this.isChatRoute || this.isFinancialDocumentsRoute)
    );
  }

  getMobileConnectionCtaActionLabel(): string {
    return 'Ir a mis conexiones';
  }

  handleMobileConnectionCta(): void {
    if (!this.shouldShowConnectionBanner()) {
      this.setConnectionDropdownVisibility(true);
      return;
    }

    this.setConnectionDropdownVisibility(false);
    this.router.navigate(['/dashboard/connections']);
  }

  private persistSelectedConnectionId(
    connectionType: string,
    connectionId: number,
  ): void {
    try {
      const currentRaw = localStorage.getItem(
        TopNavbarComponent.SELECTED_CONNECTION_IDS_KEY,
      );
      const currentMap = currentRaw ? JSON.parse(currentRaw) : {};
      currentMap[connectionType] = connectionId;
      localStorage.setItem(
        TopNavbarComponent.SELECTED_CONNECTION_IDS_KEY,
        JSON.stringify(currentMap),
      );
    } catch {
      // Ignore cache/localStorage errors.
    }
  }

  private syncSelectedConnectionsFromBackend(): void {
    this.connectionsStore.loadAll().subscribe({
      next: (connections) => {
        if (Array.isArray(connections)) {
          const selectedTypes = connections
            .filter((connection) => connection.is_active && connection.is_default)
            .map((connection) => `conn_${connection.id}`)
            .slice(-1);

          this.selectedConnections = selectedTypes;
          localStorage.setItem(
            'selectedConnections',
            JSON.stringify(this.selectedConnections),
          );
          this.syncGlobalSelectedChatConnection();
          this.applyConnectionUiRules();
          this.cdr.markForCheck();
        }
      },
      error: () => {
        this.selectedConnections = [];
        localStorage.setItem('selectedConnections', JSON.stringify([]));
        this.connectionsStateService.setSelectedChatConnection(null);
        this.applyConnectionUiRules();
        this.cdr.markForCheck();
      },
    });
  }

  private syncSelectionWithAvailableConnections(): void {
    const availableConnectionIds = new Set(
      this.getConnectionsConnected().map(c => c.id),
    );

    const nextSelection = this.selectedConnections
      .filter((connectionId) => availableConnectionIds.has(connectionId))
      .slice(-1);

    const hasChanged =
      nextSelection.length !== this.selectedConnections.length ||
      nextSelection[0] !== this.selectedConnections[0];

    if (!hasChanged) {
      return;
    }

    this.selectedConnections = nextSelection;
    localStorage.setItem(
      'selectedConnections',
      JSON.stringify(this.selectedConnections),
    );
    this.syncGlobalSelectedChatConnection();
    this.applyConnectionUiRules();
    this.applyMobileChatHeaderDefaultCollapse();
    this.cdr.markForCheck();
  }

  private ensureDefaultConnectionSelectionForNewChat(): void {
    if (!this.isNewChat || this.companyContextEnabled || this.selectedConnections.length > 0) {
      return;
    }

    const preferredConnection = this.getPreferredConnectionForAutoSelection();
    if (!preferredConnection) {
      return;
    }

    this.selectConnectionAsActive(preferredConnection, false);
  }

  private getPreferredConnectionForAutoSelection(): Connection | null {
    if (!this.realConnections.length) {
      return null;
    }

    const defaultConnection = this.realConnections.find((connection) => connection.is_default);
    return defaultConnection || this.realConnections[0] || null;
  }

  private setConnectionDropdownVisibility(isVisible: boolean): void {
    if (this.showConnectionDropdown === isVisible) {
      return;
    }

    this.showConnectionDropdown = isVisible;
    this.connectionDropdownHasMoreBelow =
      isVisible && this.getConnectionsConnected().length > (this.isMobile ? 5 : 8);

    setTimeout(() => {
      this.refreshConnectionDropdownScrollHint();
      this.updateChatHeaderOffset();
      this.cdr.markForCheck();
    }, 0);
  }

  private refreshConnectionDropdownScrollHint(): void {
    if (!this.showConnectionDropdown) {
      this.connectionDropdownHasMoreBelow = false;
      return;
    }

    const menu = this.getVisibleConnectionDropdownMenu();
    this.connectionDropdownHasMoreBelow = this.hasScrollableContentBelow(menu);
  }

  private getVisibleConnectionDropdownMenu(): HTMLElement | null {
    const menus = Array.from(
      document.querySelectorAll<HTMLElement>(
        '.connection-dropdown, .mobile-chat-header__dropdown',
      ),
    );

    return menus.find((menu) => {
      const styles = window.getComputedStyle(menu);
      return styles.display !== 'none' && styles.visibility !== 'hidden';
    }) || null;
  }

  private hasScrollableContentBelow(element: HTMLElement | null): boolean {
    if (!element) {
      return false;
    }

    return element.scrollTop + element.clientHeight < element.scrollHeight - 2;
  }

  private applyMobileChatHeaderDefaultCollapse(): void {
    if (
      this.isMobile &&
      this.shouldShowMobileChatHeader() &&
      this.hasSelectedConnection() &&
      !this.hasUserToggledMobileChatHeader
    ) {
      this.isMobileChatHeaderCollapsed = true;
      setTimeout(() => this.updateChatHeaderOffset(), 0);
    }
  }

  private isChatContextRoute(): boolean {
    return this.isChatRoute || this.isFinancialDocumentsRoute;
  }

  private hasConnectionsAvailableToSelect(): boolean {
    return this.getConnectionsConnected().length > 0;
  }

  private shouldShowConnectionBanner(): boolean {
    return (
      this.isChatContextRoute() &&
      !this.hasSelectedConnection() &&
      !this.companyContextEnabled &&
      !this.hasConnectionsAvailableToSelect()
    );
  }

  private shouldAutoOpenConnectionDropdown(): boolean {
    return (
      this.isChatContextRoute() &&
      !this.hasSelectedConnection() &&
      !this.companyContextEnabled &&
      this.hasConnectionsAvailableToSelect()
    );
  }

  private applyConnectionUiRules(): void {
    const shouldAutoOpen = this.shouldAutoOpenConnectionDropdown();

    if (shouldAutoOpen && !this.hasAutoOpenedConnectionDropdown) {
      this.hasAutoOpenedConnectionDropdown = true;
      this.setConnectionDropdownVisibility(true);
      return;
    }

    if (!shouldAutoOpen) {
      this.hasAutoOpenedConnectionDropdown = false;
    }

    if (
      this.showConnectionDropdown &&
      !this.hasConnectionsAvailableToSelect() &&
      !this.hasSelectedConnection()
    ) {
      this.setConnectionDropdownVisibility(false);
    }
  }

  private syncGlobalSelectedChatConnection(): void {
    const selectedConnectionId = this.selectedConnections[0];

    if (!selectedConnectionId) {
      this.connectionsStateService.setSelectedChatConnection(null);
      return;
    }

    const selectedConnection = this.realConnections.find(
      (connection) => `conn_${connection.id}` === selectedConnectionId,
    );

    if (selectedConnection) {
      this.connectionsStateService.setSelectedChatConnection(selectedConnection);
    }
  }

  private syncSelectedConnectionsWithGlobalSelection(
    connection: SelectedChatConnection | null,
  ): void {
    const nextSelection = connection ? [`conn_${connection.id}`] : [];
    const hasChanged =
      nextSelection.length !== this.selectedConnections.length ||
      nextSelection[0] !== this.selectedConnections[0];

    if (!hasChanged) {
      return;
    }

    this.selectedConnections = nextSelection;
    localStorage.setItem(
      'selectedConnections',
      JSON.stringify(this.selectedConnections),
    );
    this.applyConnectionUiRules();
    this.applyMobileChatHeaderDefaultCollapse();
    this.cdr.markForCheck();
  }

  private clearSelectedConnectionSelection(): void {
    if (this.selectedConnections.length > 0) {
      this.selectedConnections = [];
      localStorage.setItem('selectedConnections', JSON.stringify([]));
    }

    this.setConnectionDropdownVisibility(false);
    this.cdr.markForCheck();
  }

  private applyDefaultFlagInStore(defaultConnectionId: number): void {
    const previousDefault = this.realConnections.find(
      (connection) => connection.is_default && connection.id !== defaultConnectionId,
    );

    if (previousDefault) {
      this.connectionsStore.patch(previousDefault.id, { is_default: false });
    }
    this.connectionsStore.patch(defaultConnectionId, { is_default: true });
    this.realConnections = this.realConnections.map((connection) => ({
      ...connection,
      is_default: connection.id === defaultConnectionId,
    }));
  }

  private displaySyncErrorAndReset(): void {
    console.warn('No se encontró la conexión seleccionada en el listado activo.');
    this.syncSelectedConnectionsFromBackend();
  }

  private rebuildConnectedConnections(): void {
    this.connectedConnections = this.realConnections.map((conn) => {
      const genericConnection = getAllConnections().find(
        (connection) => connection.id === conn.type,
      );

      return {
        id: `conn_${conn.id}`,
        name: conn.db_alias || conn.connection_name || `${conn.type} (${conn.id})`,
        type: conn.type as any,
        icon: genericConnection?.icon,
        imageUrl: genericConnection?.imageUrl,
        description: genericConnection?.description,
      } as AgentConnection;
    });
  }

  /**
   * Verifica si hay al menos una conexión activa (conectada al servidor)
   */
  hasActiveConnection(): boolean {
    const allConnections = getAllConnections();
    return allConnections.some((connection) =>
      this.isConnectionConnected(connection.id),
    );
  }

  /**
   * Maneja error de imagen
   */
  onImageError(event: any): void {
    const img = event.target as HTMLImageElement;
    img.style.display = 'none';
    const fallback = img.nextElementSibling as HTMLElement;
    if (fallback) {
      fallback.style.display = 'flex';
    }
  }

  /**
   * Obtiene las conexiones activas (conectadas al servidor)
   */
  getActiveConnections(): AgentConnection[] {
    const allConnections = getAllConnections();
    return allConnections.filter((connection) =>
      this.isConnectionConnected(connection.id),
    );
  }

  /**
   * Obtiene las clases de color para el icono de conexión basado en su estado
   */
  getConnectionIconClasses(connection: AgentConnection): string {
    return ConnectionsDisplayUtils.getConnectionIconClasses(
      connection.id,
      this.connectionsStateService,
    );
  }

  /**
   * Obtiene las clases de color para el borde de la conexión
   */
  getConnectionBorderClasses(connection: AgentConnection): string {
    return ConnectionsDisplayUtils.getConnectionBorderClasses(
      connection.id,
      this.connectionsStateService,
    );
  }

  /**
   * Obtiene todas las conexiones disponibles
   */
  getAllAvailableConnections(): AgentConnection[] {
    return getAllConnections();
  }

  /**
   * Verifica si una conexión está conectada al servidor
   */
  isConnectionConnected(connectionId: string): boolean {
    return this.connectionsStateService.isConnectionConnected(connectionId);
  }

}
